import ReactDom from "react-dom";
import ModalLink from "./ModalLink.jsx";

// we want to be able to render modals in a given container (like another modal).
// default to the document
export default function renderModalLink(element = document) {
  element.querySelectorAll(".js-modal-link-mount").forEach((mount) => {
    // checking data-model to exist is needed, if not JSON.parse("") will fail
    const data =
      mount.getAttribute("data-model") &&
      JSON.parse(mount.getAttribute("data-model"));

    if (!data || !mount.innerHTML) return;

    ReactDom.render(
      <ModalLink {...data} modalContent={mount.innerHTML} />,
      mount,
    );

    // it's hidden initally so the user doesn't see the button/form html
    mount.style.display = "block";
  });
}
